import React from 'react';
import Colortheme from '../Theme/Colortheme';
import DrawableCanvas from './Canvas/DrawableCanvas';
import IdleCanvas from './Canvas/IdleCanvas';
import LobbyConnection from '../Lobby/LobbyConnection';
import Player from '../Models/Player';
import PlayerCard from './Players/PlayerCard';
import BasicButton from './Button/BasicButton';
import BasicSelect from './Text/BasicSelect';
import Timer from './Drawing/Timer';
import MediaQuery from 'react-responsive'
import Constants from '../Constants';
import { revealPrompt, stringHash } from '../Utils/StringUtils'
import blankButtonStyle from '../style/BlankButtonStyle';
import alertify from 'alertifyjs';
import RevealCanvas from './Canvas/RevealCanvas';
import Cookies from 'js-cookie';
import getDrawFunc from './Canvas/DrawingStrategies'
import { messyBorderStyle } from '../Utils/StyleUtils';
import URLs from '../Utils/URLUtils';
import HiddenLobbyCode from './Text/HiddenLobbyCode';
import TipsAndTricks from './Text/TipsAndTricks';

class Game extends React.Component {

    constructor(props) {
        super(props);
        this._canvas = React.createRef();

        var id = Cookies.get("userID")
        if (!id) {
            id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
            Cookies.set("userID", id, { expires: 5000, secure: true, sameSite: 'lax' })
        }

        this.state = {
            stage: 'connecting',
            width: 0,
            player: new Player(this.props.location.state.playername, this.props.location.state.avatar, id, null),
            allPlayers: {},
            connectedPlayers: {},
            settings: {},
            canvasData: {
                background: '#FFFFFF',
                pen: {
                    paths: [],
                },
                marker: {
                    paths: [],
                },
                existing: []
            },
        }

        this.exportRef = React.createRef();

        this.playersUpdated = this.playersUpdated.bind(this);
        this.publicIdUpdated = this.publicIdUpdated.bind(this);
        this.stateUpdateGame = this.stateUpdateGame.bind(this);
        this.stateUpdateLobby = this.stateUpdateLobby.bind(this);
        this.stateUpdateReveal = this.stateUpdateReveal.bind(this);
        this.cannotJoin = this.cannotJoin.bind(this);
        this.disconnected = this.disconnected.bind(this);
        this.sendDrawing = this.sendDrawing.bind(this);
        this.updateTimer = this.updateTimer.bind(this);
        this.playAgain = this.playAgain.bind(this);
    }

    init() {
        this.lobbyConnection = new LobbyConnection(this.state.player, this.props.match.params.lobbyCode, {
            playersUpdatedCallback: this.playersUpdated,
            stateUpdateLobbyCallback: this.stateUpdateLobby,
            stateUpdateGameCallback: this.stateUpdateGame,
            stateUpdateRevealCallback: this.stateUpdateReveal,
            publicIdUpdatedCallback: this.publicIdUpdated,
            sendDrawingCallback: this.sendDrawing,
            cannotJoinCallback: this.cannotJoin,
            disconnectedCallback: this.disconnected
        });
    }

    componentDidMount() {
        this.init();

        var divStyle = getComputedStyle(this.contentDiv);

        var divWidth = this.contentDiv.clientWidth;
        var maxHeight = this.contentDiv.parentElement.parentElement.clientHeight;
        divWidth -= parseFloat(divStyle.paddingLeft) + parseFloat(divStyle.marginLeft) + parseFloat(divStyle.paddingRight) + parseFloat(divStyle.marginRight);

        this.setState({
            width: Math.min(divWidth, maxHeight * 0.7)
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.lobbyCode !== this.props.match.params.lobbyCode) {
            this.lobbyConnection.close()
            this.init();
        }
    }

    componentWillUnmount() {
        this.lobbyConnection.close()
    }

    stateUpdateLobby(players, settings) {
        this.setState({
            allPlayers: players.allPlayers,
            connectedPlayers: players.connected,
            stage: 'lobby',
            settings: settings,
        });
    }

    updateTimer() {
        this.setState((state) => ({
            nextRound: Math.floor(Math.max(0, state.nextRoundTimestamp - new Date().getTime()) / 1000)
        }));
        if (this.state.nextRoundTimestamp < new Date().getTime() && this.state.stage == 'drawing') {
            this.setState({
                stage: 'waiting_next_round'
            });
        }
        setTimeout(this.updateTimer, 1000);
    }

    stateUpdateGame(round, prompt, numRounds, roundLength, nextRound, drawing) {
        this.setState({
            stage: 'drawing',
            round: round,
            prompt: prompt,
            nextRoundTimestamp: new Date().getTime() + 1000 * nextRound,
            nextRound: nextRound,
            settings: {
                ...this.state.settings,
                roundLength: roundLength,
            },
            numRounds: numRounds,
            canvasData: {
                ...this.state.canvasData,
                pen: {
                    paths: drawing.paths[round]?.pen.paths ?? []
                },
                marker: {
                    paths: drawing.paths[round]?.marker.paths ?? []
                },
                existing: drawing.paths.slice(0, round)
            },
        });

        this.updateTimer();
    }

    stateUpdateReveal(prompts, drawings) {
        this.setState({
            stage: 'reveal',
            reveal: {
                prompts: prompts,
                drawings: drawings
            }
        })
    }

    playersUpdated(data) {
        this.setState({
            connectedPlayers: data.connected,
            allPlayers: data.allPlayers
        });
    }

    publicIdUpdated(id) {
        this.setState((state) => {
            var player = state.player
            player.publicId = id
            return {
                player: player
            }
        });
    }

    cannotJoin() {
        this.setState({
            stage: 'cannot_join'
        });
    }

    disconnected() {
        this.setState({
            stage: 'disconnected'
        });
    }

    sendDrawing() {
        var drawingData = {
            pen: this.state.canvasData.pen,
            marker: this.state.canvasData.marker
        }
        this.lobbyConnection.sendDrawing(drawingData, this.state.round);
        this.setState({
            stage: 'waiting_next_round'
        });
    }

    updateSettings(settings) {
        const newSettings = {
            ...this.state.settings,
            ...settings
        }

        this.setState({
            settings: newSettings
        })
        this.lobbyConnection.updateSettings(newSettings);
    }

    async playAgain() {
        var response = await fetch(`${URLs.apiURL}/newlobbycode?current=${this.props.match.params.lobbyCode}`);
        var code = await response.text();
        this.props.history.push({
            pathname: `/lobby/${encodeURIComponent(code)}`,
            state: {
                playername: this.props.location.state.playername,
                avatar: this.props.location.state.avatar,
            }
        });
    }

    displayLobby() {
        const boredtoggle = <BasicButton height={'50px'} background={Colortheme.hintColor} color={'#565656'} onClick={() => this.setState({ bored: !this.state.bored })}>I'm bored</BasicButton>
        var before = <div />
        var after = <div />
        const gameLengths = ['Quick', 'Normal', 'Long'];
        const roundLengths = [30, 45, 60, 90, 120];
        if (this.state.allPlayers[this.state.player.publicId]?.isAdmin) {
            const settings = [
                <BasicSelect key={"round_length"} onChange={(val) => this.updateSettings({ roundLength: parseInt(val) })} leadingText={'Drawing time:'} afterText={'Seconds'} value={roundLengths.indexOf(this.state.settings.roundLength)}>
                    {roundLengths}
                </BasicSelect>,
                <BasicSelect key={"game_length"} onChange={(_, i) => this.updateSettings({ gameLength: i })} leadingText={'Game length:'} afterText={''} value={this.state.settings.gameLength}>
                    {gameLengths}
                </BasicSelect>
            ];
            before = <div>
                <MediaQuery minWidth={Constants.minDesktopSize}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                    }}>
                        {settings}
                    </div>
                </MediaQuery>
                <MediaQuery maxWidth={Constants.minDesktopSize - 1}>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "left",
                        flexWrap: "wrap",
                    }}>
                        {settings}
                    </div>
                </MediaQuery>
            </div>
            after = <div>{boredtoggle} <BasicButton height={"50px"} onClick={() => this.lobbyConnection.startGame(this.state.settings)}>Let's goo</BasicButton></div>
        } else {
            const settings = [
                <div key={"round_length"} style={{ padding: '.5em', textAlign: 'start' }}>
                    Drawing time: <span style={{ border: '1px solid black', padding: '.25em' }}>{this.state.settings.roundLength} Seconds</span>
                </div>,
                <div key={"game_length"} style={{ padding: '.5em', textAlign: 'start' }}>
                    Game length: <span style={{ border: '1px solid black', padding: '.25em' }}>{gameLengths[this.state.settings.gameLength]}</span>
                </div>
            ];
            before = <div>
                <MediaQuery minWidth={Constants.minDesktopSize}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                    }}>
                        {settings}
                    </div>
                </MediaQuery>
                <MediaQuery maxWidth={Constants.minDesktopSize - 1}>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                    }}>
                        {settings}
                    </div>
                </MediaQuery>
            </div>
            after = <div><b>Please wait for the admin to start the game</b> <br /><br /> {boredtoggle}</div>
        }

        return <div>
            {before}
            {Object.entries(this.state.connectedPlayers).map(([id, player]) => (
                <PlayerCard key={id} player={player} highlight={player.publicId === this.state.player.publicId} />
            ))}
            {after}
            <HiddenLobbyCode code={this.props.match.params.lobbyCode} copyToClipboard={this.copyToClipboard} />
            {this.state.bored ? <IdleCanvas width={this.state.width} /> : <div />}
            <TipsAndTricks maxWidth={"500px"} color={"black"} />
        </div>
    }

    displayDrawing() {
        var canvas = <DrawableCanvas width={this.state.width} canvasData={this.state.canvasData}
            onPathAdded={(data) => this.lobbyConnection.appendPath(data, this.state.round)}
            onUndoMarker={() => this.lobbyConnection.undoMarker()}
            onUndoPen={() => this.lobbyConnection.undoPen()}
            onCanvasDataChange={(canvasData) => this.setState({ canvasData: canvasData })}
        />

        if (!this.state.prompt) {
            return canvas
        }
        return <div>
            <div style={{
                display: 'flex',
                flexDirection: 'horizontal',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: this.state.width,
                padding: '.5em',
                boxSizing: 'border-box'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'left',
                }}>
                    <div style={{ textAlign: 'start' }}><b>Draw {this.state.prompt}</b></div>
                    <div style={{ whiteSpace: 'nowrap', textAlign: 'start' }}>Round {this.state.round + 1} of {this.state.numRounds}</div>
                </div>
                <Timer size='3em' timeLeft={this.state.nextRound} />
            </div>
            {canvas}
        </div>
    }

    copyToClipboard(value) {
        var copyText = document.createElement("textarea")
        copyText.setAttribute('contenteditable', true)
        copyText.style.position = 'absolute'
        copyText.style.top = '-1000px'

        document.body.appendChild(copyText);

        copyText.value = value;
        copyText.select();
        document.execCommand('copy');

        document.body.removeChild(copyText);

        alertify.warning('copied link to clipboard')
    }

    handleShare(canvasData, prompt, label) {
        const responseToURL = (v) => {
            const [imgurl, deleteHash] = v.split(";;")
            const imgHash = imgurl.split("/")[3].split(".")[0]
            return `${URLs.shareURL}/${encodeURIComponent(imgHash)}`
        }
        const drawingId = `${stringHash(prompt)}`
        this.lobbyConnection.isCached(drawingId, (cache) => {
            if (cache) {
                this.copyToClipboard(responseToURL(cache))
            } else {
                alertify.warning("uploading your art, please be patient")

                const exportContext = this.exportRef.current.getContext('2d')

                exportContext.lineCap = 'round';

                const drawFunc = getDrawFunc();
                exportContext.fillStyle = canvasData.background;
                exportContext.fillRect(0, 0, exportContext.canvas.width, exportContext.canvas.height);
                for (var existing of canvasData.existing ?? []) {
                    var markerPaths = existing.marker.paths ?? [];
                    var penPaths = existing.pen.paths ?? [];
                    drawFunc(markerPaths, markerPaths, exportContext);
                    drawFunc(penPaths, penPaths, exportContext);
                }
                const dataurl = this.exportRef.current.toDataURL("image/png").split(',')[1]

                this.lobbyConnection.share(drawingId, dataurl, prompt, label, (response, err) => {
                    if (err) {
                        alertify.error("something went wrong, please try again later");
                    } else {
                        this.copyToClipboard(responseToURL(response))
                    }
                })
            }
        });
    }

    displayReveal() {
        var canvasSize = this.state.width
        if (this.state.width > 600) {
            canvasSize *= 0.8
        }

        return <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'row',
            justifyContent: 'space-around',
            width: this.state.width,
            boxSizing: 'border-box'
        }}>
            <canvas ref={this.exportRef} width={Constants.drawingShareSize} height={Constants.drawingShareSize} style={{ display: "none" }} />

            <div style={{
                width: this.state.width,
                textAlign: 'center',
                padding: '10px',
                fontSize: '3em',
                fontWeight: 'bold',
                fontFamily: 'Fancy Pants NF'
            }}>
                Art Gallery
            </div>
            {this.state.reveal.drawings.map((drawing, index) => {
                var data = {
                    background: '#FFFFFF',
                    pen: { paths: [] },
                    marker: { paths: [] },
                    existing: drawing.paths,
                }
                return <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexWrap: 'nowrap',
                    paddingTop: '.5em',
                    paddingBottom: '.5em',
                    width: canvasSize,
                }} key={index}>
                    <RevealCanvas width={canvasSize} data={data} label={drawing.label} />
                    <div style={{
                        fontWeight: 'bold',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: "center",
                        width: canvasSize,
                        boxSizing: 'border-box',
                        paddingTop: '.5em',
                        paddingBottom: '.5em',
                    }}>
                        {revealPrompt(this.state.reveal.prompts[index])}
                        <button style={blankButtonStyle} onClick={() => this.handleShare(data, revealPrompt(this.state.reveal.prompts[index]), drawing.label)}>
                            <img src={process.env.PUBLIC_URL + '/assets/icons/128/share.jpg'} alt="share" style={{ width: "2em" }} className="icon" />
                        </button>
                    </div>
                </div>
            })}
            {this.state.allPlayers[this.state.player.publicId] &&
                <div style={{
                    width: this.state.width,
                }}>
                    <BasicButton height={'50px'} onClick={this.playAgain}>Play Again</BasicButton>
                </div>}
        </div>
    }

    displayWaiting() {
        if (this.state.round === this.state.numRounds - 1) {
            return <div>
                <h2>Collecting your drawings!</h2>
                <p>Sit back, relax and get ready for the great reveal</p>
            </div>
        }
        return <div>
            <h2>Next round coming up!</h2>
            <p>Sit back, relax and recharge your creativity battery</p>
        </div>
    }

    displayErrorMessage(message) {
        return <div>
            <p><b>{message}</b></p>
            <IdleCanvas width={this.state.width} />
        </div>
    }

    currentContent() {
        switch (this.state.stage) {
            case 'connecting':
                return <div><p>Connecting...</p></div>
            case 'cannot_join':
                return this.displayErrorMessage('This game has already started. Try joining another lobby')
            case 'lobby':
                return this.displayLobby()
            case 'drawing':
                return this.displayDrawing()
            case 'waiting_next_round':
                return this.displayWaiting()
            case 'reveal':
                return this.displayReveal()
            default:
                return this.displayErrorMessage('Something went wrong. Please try refreshing the page or joining another lobby')
        }
    }

    displayPlayerSidebar(title, status) {
        const fullWidth = 300;
        const collapsedwidth = 70;
        const margin = 100;

        const minFullWidth = this.state.width + fullWidth * 2 + margin;
        const minCollapsedWidth = this.state.width + collapsedwidth * 2 + margin;

        const titleStyle = {
            fontWeight: 'bold',
            padding: '10px',
            paddingBottom: '0px',
            textAlign: 'center',
        }

        return <div>
            <MediaQuery minWidth={minFullWidth}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    width: `${fullWidth}px`,
                    boxSizing: 'border-box',
                    backgroundColor: 'white',
                    boxShadow: `0px 4px 15px 1px ${Colortheme.shadowColor}`,
                    WebkitBoxShadow: `0px 4px 15px 1px ${Colortheme.shadowColor}`,
                    ...messyBorderStyle("player_sidebar"),
                }}>
                    {title && <div style={titleStyle}>{title}</div>}
                    {Object.entries(this.state.allPlayers).map(([id, player]) => {
                        var gifURL = status?.imgURL;
                        var height = status?.height;
                        var rightPadding = status?.rightPadding;
                        if (!this.state.connectedPlayers[id]) {
                            gifURL = process.env.PUBLIC_URL + "/assets/icons/128/wifi.gif";
                            height = "30px";
                            rightPadding = "10px";
                        }
                        return <div style={{ position: 'relative' }} key={id}>
                            <PlayerCard player={player} hideAdminIndicator={true} />
                            <img src={gifURL} height={height} className="icon" style={{
                                position: 'absolute',
                                paddingRight: rightPadding,
                                paddingLeft: '10px',
                                right: 20,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                backgroundColor: 'white',
                            }} />
                        </div>
                    })}
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={minFullWidth - 1} minWidth={minCollapsedWidth}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    width: `${collapsedwidth}px`,
                    boxSizing: 'border-box',
                    backgroundColor: 'white',
                    ...messyBorderStyle("player_sidebar"),
                    justifyContent: 'center',
                    alignContent: 'space-around',
                    alignItems: 'center',
                    padding: '10px',
                    boxShadow: `0px 4px 15px 1px ${Colortheme.shadowColor}`,
                    WebkitBoxShadow: `0px 4px 15px 1px ${Colortheme.shadowColor}`,
                }}>
                    {Object.entries(this.state.allPlayers).map(([id, player]) => {
                        return <img src={`${process.env.PUBLIC_URL}/assets/avatars/128/${player.avatar}.gif`} height={"50px"} alt="" key={id} className="icon" />
                    })}
                </div>
            </MediaQuery>
        </div>
    }

    leftSidebar() {
        switch (this.state.stage) {
            case 'drawing':
                return this.displayPlayerSidebar("", {
                    imgURL: process.env.PUBLIC_URL + "/assets/icons/128/drawing_animation.gif",
                    height: "50px",
                    rightPadding: "0px",
                })
            case 'waiting_next_round':
                return this.displayPlayerSidebar("", {
                    height: "50px",
                })
            case 'reveal':
                return this.displayPlayerSidebar("Artists", {
                    height: "50px",
                })
        }
        return <div />
    }

    render() {

        const centerFieldStyle = {
            ...messyBorderStyle("main_game"),
            padding: '20px',
            margin: '10px',
            backgroundColor: '#FFFFFF',
            maxWidth: '800px',
            flex: '0 1 100%',
            boxSizing: 'border-box',
            boxShadow: `0px 4px 15px 1px ${Colortheme.shadowColor}`,
            WebkitBoxShadow: `0px 4px 15px 1px ${Colortheme.shadowColor}`,
        }

        return <div style={{
            display: 'flex',
        }}>
            <div style={{
                flex: '1 1 0%',
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '10px',
            }}>
                {this.leftSidebar()}
            </div>
            <div style={centerFieldStyle} ref={(div) => { this.contentDiv = div }}>
                {this.currentContent()}
            </div>
            <div style={{ flex: '1 1 0%' }} />
        </div>
    }
}

export default Game;